<script>
import ListOrderAdmin from "@/components/admin/orders/ListOrderAdmin.vue";

export default {
  name: 'OrderAdmin',
  components: {ListOrderAdmin}
}
</script>

<template>
<div>
  <list-order-admin />
</div>
</template>

